import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogMessageService } from '../../services/dialog-message.service';
import { MsalHelperService } from '../../services/msal-helper.service';
import { OrgManagementService } from '../../services/org-management.service';
import { UserService } from '../../services/user.service';
import { User } from '../../types/user';

@Component({
    selector: 'nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss'],
    standalone: false
})
export class NavMenuComponent implements OnInit {
  @Input() user: User;

  constructor(
    private readonly router: Router,
    private readonly userService: UserService,
    private readonly msalHelper: MsalHelperService,
    private readonly messageService: DialogMessageService,
    private readonly orgManagementService: OrgManagementService
  ) { }

  ngOnInit(): void {
    this.msalHelper.runAfterAuthenticated(() => {
      this.userService.currentUser.subscribe({
        next: (response) => this.user = response,
        error: (error) => this.messageService.openErrorMessage(error)
      });
    });
  }

  isAdmin(): boolean {
    return this.router.url.startsWith('/admin');
  }

  isUserActive(): boolean {
    return this.user.organizations.length > 0;
  }
}
